import { Alert, Button, Col, Form, Input, Row, Spin } from "antd";
import { useState } from "react";

import { registrarAccesoProveedor } from "../../services/services";
import { formatCUITCUILWithoutDash, isProveedorAutorizado } from "../../utils/utils";
import Cuit from "../cuit/cuit.component";
import { rules } from "./cuit-mail-form.rules";

import useProveedor from "../../hooks/useProveedor";
import "./cuit-mail-form.styles.css";

const colLayout = { xs: 24, sm: 24, md: 12, lg: 8 };

;
const CuitMailForm = () => {
    const [form] = Form.useForm();

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const { onRegistrarAccesoProveedor } = useProveedor();

    const onSubmit = (values) => {
        const request = {
            ...values,
            cuit: formatCUITCUILWithoutDash(values.cuit),
        };

        setLoading(true);
        registrarAccesoProveedor(request)
            .then((res) => {
                if (res.status !== 200)
                    throw Error(
                        "Se produjo un error al consultar los datos. Inténtelo nuevamente"
                    );
                return res.json();
            })
            .then((data) => {
                if (data.status === "FAIL") throw Error(data.message);
                setError(null);
                setLoading(false);

				const isAutorizado = isProveedorAutorizado(data.message);
				
				onRegistrarAccesoProveedor(request.cuit, isAutorizado);
            })
            .catch((error) => {
                setError(error.message);
                onRegistrarAccesoProveedor(null);
                setLoading(false);
            });
    };

    return (
        <>
            <div style={{ marginTop: "20px", position: "relative" }}>
                <Form
                    form={form}
                    name='cuitMailForm'
                    layout='vertical'
                    requiredMark={false}
                    onFinish={onSubmit}
                >
                    <Spin tip='Cargando...' spinning={loading}>
                        <Row gutter={[16]}>
                            <Col {...colLayout} lg={6}>
                                <Cuit form={form} />
                            </Col>

                            <Col {...colLayout}>
                                <Form.Item
                                    label='Email'
                                    name='email'
                                    validateTrigger={false}
                                    rules={[...rules.email]}
                                >
                                    <Input size='large' />
                                </Form.Item>
                            </Col>
                            <Col {...colLayout} lg={4}>
                                <div style={{ marginTop: "30px" }}>
                                    <Button
                                        block
                                        type='primary'
                                        htmlType='submit'
                                        size='large'
                                    >
                                        CONSULTAR
                                    </Button>
                                </div>
                            </Col>
                        </Row>
                    </Spin>
                </Form>
            </div>
            {error && (
                <Alert
                    message='Error'
                    description={error}
                    type='error'
                    showIcon
                />
            )}
        </>
    );
};

export default CuitMailForm;
